export const seasonOptions = [
    {
        id: 0,
        value: 'Verano'
    },
    {
        id: 1,
        value: 'Invierno'
    }
]

export const farmingYears = [
    {
        id: 0,
        value: '20/21'
    },
    {
        id: 1,
        value: '21/22'
    },
    {
        id: 2,
        value: '23/24'
    }
]

export const boolOptions = [
    {
        value: true,    
        description: 'Si'
    },
    {
        value: false,
        description: 'No'
    }
]

export const ActiveOptions = [
    {
        value: true,    
        description: 'Activos'
    },
    {
        value: false,
        description: 'Inactivos'
    }
]
export const ActivesOptions = [
    {
        value: true,    
        description: 'Activas',
        id: 2
    },
    {
        value: false,
        description: 'Inactivas',
        id: 1
    }
]

export const SeenOptions = [
    {
        value: true,    
        description: 'Vistas'
    },
    {
        value: false,
        description: 'No vistas'
    }
]